import { render, staticRenderFns } from "./window.vue?vue&type=template&id=fce59d98&scoped=true&"
import script from "./window.vue?vue&type=script&lang=js&"
export * from "./window.vue?vue&type=script&lang=js&"
import style0 from "./window.vue?vue&type=style&index=0&id=fce59d98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce59d98",
  null
  
)

export default component.exports